import { render, staticRenderFns } from "./EmployerResources.vue?vue&type=template&id=4d5e9155&"
import script from "./EmployerResources.vue?vue&type=script&lang=js&"
export * from "./EmployerResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports